import axios from 'axios'
import {
  getLocalStorage,
  getSessionStorage,
  TEXT_ENCRYPT,
  removeLocalStorage
} from '../helpers'

const getConfig = accessToken => {
  const config = {
    baseURL: process.env.REACT_APP_BASE_API_URL,
    headers: {
      'Access-Control-Allow-Origin': '*'
    }
  }

  if (accessToken) {
    config.headers.Authorization = 'Bearer ' + accessToken
  }

  return config
}

const axiosSuccess = (result) => {
  if (result.status === 200 || result.status === 201) {
    return {
      data: (result.data.data ? result.data.data : result.data),
      status: true,
      textResponse: result.data.description
    }
  } else {
    console.log('ERROR axiosSuccess', result)
  }
}

const axiosError = (error) => {
  if (error.response && error.response.status === 401) {
    removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
    return {
      data: error.response.data,
      codeHTTP: error.response.status,
      status: false
    }
  } else if (error.response) {
    return {
      data: error.response.data,
      codeHTTP: error.response.status,
      status: false
    }
  } else {
    return error
  }
}

const axiosService = (type, apiPath, params) => {
  let accessToken = getLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN) || getSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
  if (params && params.accessToken) {
    accessToken = params.accessToken
  }
  let config = getConfig(accessToken)
  const url = process.env.REACT_APP_BASE_API_URL + apiPath

  const lang = getLocalStorage('booking-language') || 'EN'
  config.headers['Accept-Language'] = `${lang.toLowerCase()}-${lang}`

  switch (type) {
    case 'get':
      if (params) {
        config = {
          ...config,
          params: params
        }
      }
      return axios
        .get(url, config)
        .then(axiosSuccess)
        .catch(axiosError)
    case 'getBlob':
        config = {
          ...config,
          responseType: 'blob',
        }
      return axios
        .get(url, config)
        .then(axiosSuccess)
        .catch(axiosError)
    case 'post':
      // if (isJWTEncoded) {
      // params = jwt.sign(params, process.env.REACT_APP_JWT_SALT.toString('hex'))
      // config.headers['Content-Type'] = 'text/plain'
      //   config.headers['Content-Type'] = 'application/json'
      // } else {
      config.headers['Content-Type'] = 'application/json'
      // }
      return axios
        .post(url, params, config)
        .then(axiosSuccess)
        .catch(axiosError)

    case 'put':
      // if (isJWTEncoded) {
      // params = jwt.sign(params, process.env.REACT_APP_JWT_SALT.toString('hex'))
      // config.headers['Content-Type'] = 'text/plain'
      //   config.headers['Content-Type'] = 'application/json'
      // } else {
      config.headers['Content-Type'] = 'application/json'
      // }
      return axios
        .put(url, params, config)
        .then(axiosSuccess)
        .catch(axiosError)

    case 'patch':
      config.headers['Content-Type'] = 'application/json'
      return axios
        .patch(url, params, config)
        .then(axiosSuccess)
        .catch(axiosError)

    case 'delete':
      // if (isJWTEncoded) {
      // params = jwt.sign(params, process.env.REACT_APP_JWT_SALT.toString('hex'))
      // config.headers['Content-Type'] = 'text/plain'
      //   config.headers['Content-Type'] = 'application/json'
      // } else {
      // }
        
      config.headers['Content-Type'] = 'application/json'
      config = {
        ...config,
        ...params && {data: params},
      }
     
      return axios
        .delete(url, config)
        .then(axiosSuccess)
        .catch(axiosError)

    case 'postFormData':
      const formData = new FormData()
      // console.log("params", params)
      Object.keys(params).map(key => {
        const value = params[key]
        if (value && typeof value === 'object' && value.length > 0) {
          return value.map(subValue => {
            return formData.append(key, subValue)
          })
        } else return formData.append(key, params[key])
      })
      config.headers['Content-Type'] = 'multipart/form-data'
      return axios({
        method: 'post',
        url: url,
        data: formData,
        ...config
      })
        .then(axiosSuccess)
        .catch(axiosError)

    default:
      return false
  }
}

export default {
  get: (url, params, isAbsolute) => axiosService('get', url, params),
  getBlob: (url, params, isAbsolute) => axiosService('getBlob', url, params),
  post: (url, params, isAbsolute) => axiosService('post', url, params),
  put: (url, params, isAbsolute) => axiosService('put', url, params),
  patch: (url, params, isAbsolute) => axiosService('patch', url, params),
  delete: (url, params, isAbsolute) => axiosService('delete', url, params),
  postFormData: (url, params, isAbsolute) => axiosService('postFormData', url, params)
}
